import { createAsyncThunk } from '@reduxjs/toolkit';
import { ContactForm } from '../../../client/services';
import { toastHandler } from '../../../utils/toastHandler';
import { FindContactForm } from './interface';

export const findContactForm = createAsyncThunk(
  'contactForm/findContactForm',
  async (values: FindContactForm, { rejectWithValue }) => {
    try {
      const response = await ContactForm.find({
        query: values,
      });

      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const updateContactForm = createAsyncThunk(
  'contactForm/updateContactForm',
  async ({ id, data }: { id: string; data: Partial<any> }, { rejectWithValue }) => {
    try {
      const response = await ContactForm.patch(id, data);
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

